import React, { forwardRef, memo, useCallback, useContext, useRef } from 'react'
import { ScreenContext } from 'react-components'
import { HeaderSectionTransport } from '../../../transports/region-landing-page-transport'
import HeroSearchbar from './hero-searchbar'
import { BackgroundImages, Container, ContentWrapper, SubtitleWrapper, TitleWrapper } from './styles'
import { useScrollToSearch } from '../../../hooks/scroll-to-search'
import SliderSection from './slider-section'
import PageSubTypeTransport from '../../../transports/common/booking-types-transport'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface CommonHeroSectionProps {
    title: string
    subtitle: string
    backgroundImages: BackgroundImages
    logo?: Navigation['logo']
    textColor?: string
    hasOverlay?: boolean
    initialLocation?: string
    pageSubTypeResponse?: PageSubTypeTransport
    isBorderGradientEnabled?: boolean
    showSliderSection?: boolean
    isIndexableTabs?: boolean
}

const CommonHeroSection = forwardRef<HTMLDivElement, CommonHeroSectionProps>(
    (
        {
            title,
            subtitle,
            backgroundImages,
            logo,
            textColor,
            hasOverlay,
            initialLocation,
            pageSubTypeResponse,
            isBorderGradientEnabled,
            showSliderSection,
            isIndexableTabs,
        },
        ref,
    ) => {
        const { isDesktop, isTablet } = useContext(ScreenContext)
        const innerRef = useRef<HTMLDivElement>(null)
        const isSticky = useScrollToSearch(innerRef as React.RefObject<HTMLDivElement>, isDesktop || isTablet)

        const setRefs = useCallback(
            (element: HTMLDivElement | null) => {
                innerRef.current = element
                if (typeof ref === 'function') {
                    ref(element)
                } else if (ref) {
                    ref.current = element
                }
            },
            [ref],
        )

        return (
            <Container backgroundImages={backgroundImages} hasOverlay={hasOverlay}>
                <ContentWrapper ref={setRefs}>
                    <TitleWrapper textColor={textColor}>{title}</TitleWrapper>
                    <SubtitleWrapper textColor={textColor}>{subtitle}</SubtitleWrapper>
                    {showSliderSection && (
                        <SliderSection pageSubTypeResponse={pageSubTypeResponse} isIndexableTabs={isIndexableTabs} />
                    )}
                    <HeroSearchbar
                        initialLocation={initialLocation}
                        isSticky={isSticky}
                        logo={logo}
                        petsAllowed={false}
                        pageSubType={pageSubTypeResponse?.pageSubType}
                        isBorderGradientEnabled={isBorderGradientEnabled}
                    />
                </ContentWrapper>
            </Container>
        )
    },
)

CommonHeroSection.displayName = 'CommonHeroSection'

export default memo(CommonHeroSection)
